import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-scroll';

import { Typography } from '#atoms/index';
import { useWindowSize } from '#hooks/index';

const GameJamWhyParticipate = ({ scrollToWorkshop }) => {
  const { isMobile, isDesktop } = useWindowSize();

  return (
    <section className="game-jam-why-participate-Wrapper">
      <div className="game-jam-why-participate">
        {/* Title */}
        <div className="game-jam-awards__title">
          <Typography
            variant="regular regular-2 bold text-center"
            tag="h2"
            style={{ color: '#AC84FF', lineHeight: isMobile ? '44px' : '60px' }}
          >
            ¿Por qué debería participar tu <br /> hij@?
          </Typography>
        </div>

        {/* Why participate */}
        <ul className="game-jam-why-participate__list">
          <li className="game-jam-why-participate__list__item">
            <div className="game-jam-why-participate__list__item__container_img mb-4">
              <LazyLoadImage
                width={isMobile ? '53px' : '53px'}
                effect="blur"
                alt={'game-why-participate'}
                src={'./game-jam/why-participate/game.svg'}
                placeholder={<Skeleton width="100%" height="100%" />}
              />
            </div>

            <div className="game-jam-why-participate__list__item__container_text">
              <Typography
                variant="regular regular-4 bold text-center"
                tag="p"
                style={{
                  color: '#FF52E2',
                  lineHeight: '32px',
                  marginBottom: isMobile ? '14px' : '8px'
                }}
              >
                Creará su propio <br /> videojuego
              </Typography>

              <Typography
                variant="regular regular-6 text-center why-participate-text"
                tag="p"
                style={{
                  color: '#DBD1FD',
                  lineHeight: isMobile ? '20px' : '24px'
                }}
              >
                Tu hij@ dejará de ser solo un jugador y vivirá la experiencia de crear su
                propio videojuego.
              </Typography>
            </div>
          </li>

          <li className="game-jam-why-participate__list__item">
            <div className="game-jam-why-participate__list__item__container_img mb-4">
              <LazyLoadImage
                width={isMobile ? '32px' : '32px'}
                effect="blur"
                alt={'light-why-participate'}
                src={'./game-jam/why-participate/light.svg'}
                placeholder={<Skeleton width="100%" height="100%" />}
              />
            </div>

            <div className="game-jam-why-participate__list__item__container_text">
              <Typography
                variant="regular regular-4 bold text-center"
                tag="p"
                style={{
                  color: '#FF52E2',
                  lineHeight: '32px',
                  marginBottom: isMobile ? '14px' : '8px'
                }}
              >
                Estimulará <br /> su creatividad
              </Typography>

              <Typography
                variant="regular regular-6 text-center why-participate-text"
                tag="p"
                style={{
                  color: '#DBD1FD',
                  lineHeight: isMobile ? '20px' : '24px'
                }}
              >
                Lleva su talento a otro nivel potenciando sus habilidades de diseño,
                pensamiento lógico y programación.
              </Typography>
            </div>
          </li>

          <li className="game-jam-why-participate__list__item">
            <div className="game-jam-why-participate__list__item__container_img mb-4">
              <LazyLoadImage
                width={isMobile ? '51px' : '51px'}
                effect="blur"
                alt={'hands-why-participate'}
                src={'./game-jam/why-participate/hands.svg'}
                placeholder={<Skeleton width="100%" height="100%" />}
              />
            </div>

            <div className="game-jam-why-participate__list__item__container_text">
              <Typography
                variant="regular regular-4 bold text-center"
                tag="p"
                style={{
                  color: '#FF52E2',
                  lineHeight: '32px',
                  marginBottom: isMobile ? '14px' : '8px'
                }}
              >
                Vivirá una inolvidable experiencia multicultural
              </Typography>

              <Typography
                variant="regular regular-6 text-center why-participate-text"
                tag="p"
                style={{
                  color: '#DBD1FD',
                  lineHeight: isMobile ? '20px' : '24px'
                }}
              >
                Compartirá su pasión por los videojuegos con coders de todo Latinoamérica.
              </Typography>
            </div>
          </li>
        </ul>

        <Link
          className="game-jam-button"
          to="workshop"
          smooth
          duration={1000}
          offset={scrollToWorkshop}
        >
          <Typography variant="regular regular-6 bold" tag="p">
            ¡Inscripciones aquí!
          </Typography>
        </Link>
      </div>
    </section>
  );
};

export default GameJamWhyParticipate;
